module.exports = __webpack_public_path__ + "static/media/idea-logo-30years.510369bc.svg";